import React from 'react';
import './Hero.css';

// Import hero images
// NOTE: Replace .svg with .jpg when you add real photos
import heroDesktop from '../assets/hero/desktop/pozivnica_slika.jpg';
import heroMobile from '../assets/hero/mobile/pozivnica_slika.jpg';
import floralOrnament from '../assets/images/floral_ornament.png';

const Hero = ({ guestLabel, imageless = false }) => {
  return (
    <section
      className={`hero${imageless ? ' hero--imageless' : ''}`}
      aria-labelledby="hero-names"
    >
      {!imageless && (
        <>
          {/* Background Image with responsive switching */}
          <div className="hero__background">
            <picture>
              <source media="(min-width: 768px)" srcSet={heroDesktop} />
              <img
                src={heroMobile}
                alt="Romantic wedding photo of Olivia and Ethan"
              />
            </picture>
          </div>

          {/* Dark overlay for text readability */}
          <div className="hero__overlay" aria-hidden="true"></div>

          {/* Warm glow effect */}
          <div className="hero__glow" aria-hidden="true"></div>

          {/* Bottom transition gradient */}
          <div className="hero__transition" aria-hidden="true"></div>
        </>
      )}

      {/* Hero Content */}
      <div className="hero__content">
        {/* Floral ornament decoration */}
        <img
          src={floralOrnament}
          alt=""
          className="hero__ornament"
          aria-hidden="true"
        />

        <p className="hero__tagline">Vjenčanje</p>

        <h1 id="hero-names" className="hero__names">
          Ana & Josip
        </h1>

        <div className="hero__divider" aria-hidden="true"></div>

        <p className="hero__date">6. Lipnja, 2026</p>
      </div>
    </section>
  );
};

export default Hero;
